import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  public phone = '[+573133207248]';
  public title = '[ Hola Ingherrera, Deseo cotizar sus servicios. ]';

  constructor() { }

  ngOnInit(): void {
  }

}
